<template>
  <a-layout-content class="overflow-hidden">
    <div class="filter-panel">
      <a-row>
        <a-col :span="24" class="other-filter">
          <div class="mr-20">关键字:</div>
          <a-input class="mr-20" placeholder="关键字" style="width: 360px" v-model="keyword" />
          <!-- <div class="mr-20">供应商类型:</div>
          <a-select class="mr-20" style="width: 120px" v-model="type" placeholder="供应商类型" :disabled="typeDisabled">
            <a-select-option v-for="o in types" :value="o.id" :key="o.id">{{ o.name }}</a-select-option>
          </a-select> -->
          <div class="mr-20">状态:</div>
          <a-select class="mr-20" style="width: 120px" v-model="status" placeholder="状态" :disabled="typeDisabled">
            <a-select-option v-for="o in statusList" :value="o.id" :key="o.id">{{ o.name }}</a-select-option>
          </a-select>
          <a-button class="mr-20 view-btn large" html-type="submit" @click="getList(true)">搜索</a-button>
          <a-button class="mr-20 view-btn large" html-type="submit" @click="reset">重置</a-button>
        </a-col>
      </a-row>
    </div>
    <a-divider></a-divider>
    <div class="flex-container filter-panel filter-panel2">
      <sub-title>数据列表</sub-title>
    </div>
    <a-divider></a-divider>
    <a-table :columns="columns" :dataSource="logs" :rowKey="(record) => record.id+'_'+record.fullUnitName" :loading="loading"
      :scroll="{ x: 1500, y: 800 }" v-if="logs && logs.length > 0" :pagination="pagination" @change="onPageChange">
      <template slot="showTitle" slot-scope="text, record" ellipsis="...">
        <div :title="text">{{ text }}</div>
      </template>

      <template slot="showStatus" slot-scope="text, record" ellipsis="...">
        <span v-if="text">删除</span>
        <span v-else-if="record.notExists==1" style="color:red">未注册</span>
        <span v-else>正常</span>
      </template>

      <template slot="showType" slot-scope="text, record" ellipsis="...">
        <span>{{getType(text)}}</span>
      </template>

      <template slot="showMaterial" slot-scope="text, record" ellipsis="...">
        <span :title="getMaterial(record)">{{getMaterial(record)}}</span>
      </template>

      <template slot="showPicSlot" slot-scope="text, record" ellipsis="...">
        <span v-if="text && text.length > 2">
          <a-icon @click="showPic(text)" type="check-circle" theme="twoTone" two-tone-color="#52c41a"
            :style="{ fontSize: '20px' }" />
        </span>
        <span v-else>
          <a-icon type="close-circle" theme="twoTone" two-tone-color="red" :style="{ fontSize: '20px' }" />
        </span>
      </template>

      <template slot="operation" slot-scope="text, record">
        <!-- <a @click="showDept(record)" href="javascript:;">编辑</a> | -->
      </template>

      <template slot="operation" slot-scope="text, record">
        <a @click="appraise(record)" href="javascript:;">评价</a> |
        <a @click="queryAppraise(record)" href="javascript:;">查看评价</a>
      </template>
    </a-table>
    <!-- 列表表格 -->

    <!-- 证件材料预览 -->
    <a-modal v-if="preview_visible" v-model="preview_visible" :zIndex="2" width="900px" :maskClosable="false"
      :footer="null">
      <div height="325px" width="450px">
        <img :src="url" width="100%" height="100%" />
      </div>
    </a-modal>

    <a-modal title="评价" v-if="visiable_appraise" v-model="visiable_appraise" :zIndex="2" width="900px" :maskClosable="false"
      @ok="save_handle" @cancel="closeMe">
      <a-form class="modal-form" :form="form">
        <a-form-item label="供应商名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
          <a-input placeholder="供应商名称" :rows="4" disabled v-decorator="[
            'fullUnitName',
            {
              initialValue: record && record.fullUnitName,
              rules: [{ required: true, message: '供应商名称不能为空' }],
            },
          ]" />
        </a-form-item>
        <!-- <a-form-item label="供应商类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
          <a-select placeholder="供应商类型" disabled v-decorator="[
            'type',
            {
              initialValue: record && record.type
            },
          ]">
            <a-select-option v-for="o in types" :value="o.id" :key="o.id">{{ o.name }}</a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="物料名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
          <a-select placeholder="物料名称" v-decorator="[
            'extMaterialName',
            {
              initialValue: user && user.extMaterialName,
              rules: [{ required: true, message: '物料名称不能为空' }],
            },
          ]">
            <!-- <a-select-option v-for="o in record.userExts" :value="o.materialName" :key="o.materialName">{{ o.materialName }}</a-select-option> -->
            <a-select-option v-for="o in materials" :value="o" :key="o">{{ o }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="项目名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
          <a-select placeholder="项目名称" mode="combobox" v-decorator="[
            'projectName',
            {
              initialValue: record && record.projectName,
              rules: [{ required: true, message: '项目名称不能为空' }],
            },
          ]" >
            <a-select-option v-for="o in projectNames" :value="o" :key="o">{{ o }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="事宜（评价）" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
          <a-textarea placeholder="事宜（评价）" :rows="6" v-decorator="[
            'appraise',
            {
              initialValue: record && record.appraise
            },
          ]" />
        </a-form-item>
        <a-form-item label="部门" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
          <a-input placeholder="部门" :rows="4" v-decorator="[
            'deptName',
            {
              initialValue: user && user.dept_name,
              rules: [{ required: true, message: '部门不能为空' }],
            },
          ]" readonly />
        </a-form-item>
        <a-form-item label="附件" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
          <!-- <a-upload>
            <a-button>
              <a-icon type="upload" />上传
            </a-button>
          </a-upload> -->
          <a-upload
            action="/api/api/common/upload"
            list-type="picture"
            :file-list="fileList"
            @change="handleChange"
            :beforeUpload="beforeUpload"
            multiple
          >
            <a-button>
              <a-icon type="upload" />上传
            </a-button>
            <font color=red>（文件大小限制为1M）</font>
          </a-upload>
        </a-form-item>
        <a-form-item label="评价时间" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
          <a-date-picker placeholder="评价时间" :rows="4" v-decorator="[
            'appraiseTime',
            {
              initialValue: record && (record.appraiseTime ? record.appraiseTime : null),
              rules: [{ required: true, message: '评价时间不能为空' }],
            },
          ]" show-time format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-drawer :visible="appraise_visible" @close="onClose" class="custom-class" style="color: red" title="评价"
      placement="right" :width="720" :wrapStyle="{
        height: 'calc(100% - 108px)',
        overflow: 'auto',
        paddingBottom: '108px',
      }">
      <div style="height:820px;overflow-y: auto;overflow-x: hidden;">
      <a-timeline style="padding-top:15px;" mode="alternate">
        <a-timeline-item v-for="item in appraiseList" :key="item.id">
          <a-icon slot="dot" type="clock-circle-o" style="font-size: 16px;" />
          <span>
            供应商：{{ item.fullUnitName }}
            <br /> 供应商类型：{{ getType(item.type) }}
            <br /> 物料：{{ item.extMaterialName }}
            <br /> 项目名称：{{ item.projectName }}
            <br /> 事宜（评价）：{{ item.appraise }}
            <br /> 部门：{{ item.deptName }}
            <br /> 附件：<span v-html="showUrl(item.urls)"></span>
            <br /> 评价时间：{{ item.appraiseTime }}
            <br /> 操作：<span @click="deleteAppraise(item.id)" style="cursor:pointer;color:red">删除</span>
          </span>
        </a-timeline-item>
      </a-timeline>
      </div>
      <!-- <span @click="queryAppraise" style="cursor:pointer;color:blue">加载更多</span> -->
    </a-drawer>

  </a-layout-content>
</template>
<script>
import SubTitle from "@/components/common/subTitle";
import { Divider, Modal } from "ant-design-vue";
import { userListPage,save_appraise,list_appraise,delete_appraise,list_imple_by_fullUnitName } from "@/api";
import moment from "moment";
import { getUserInfo,types,materials,statusList } from "@/plugins/common";

export default {
  components: {
    SubTitle,
    ADivider: Divider,
    Modal
  },
  data() {
    return {
      materials,
      projectNames:[],
      status:undefined,
      statusList,
      types,
      // 显示列
      columns: [
        {
          title: "供应商",
          width: 200,
          dataIndex: "fullUnitName",
          key: "fullUnitName",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "社会统一信用代码",
          width: 200,
          dataIndex: "uniqueNo",
          key: "uniqueNo",
          scopedSlots: { customRender: "showTitle" },
        },
        {
          title: "营业执照",
          width: 100,
          dataIndex: "license",
          key: "license",
          scopedSlots: { customRender: "showPicSlot" },
        },
        {
          title: "授权委托书",
          width: 100,
          dataIndex: "authorization",
          key: "authorization",
          scopedSlots: { customRender: "showPicSlot" },
        },
        {
          title: "负责人姓名",
          width: 150,
          dataIndex: "cname",
          key: "cname",
        },
        {
          title: "状态",
          width: 70,
          dataIndex: "deleted_at",
          key: "deleted_at",
          scopedSlots: { customRender: "showStatus" },
        },
        /*{
          title: "类型",
          width: 70,
          dataIndex: "type",
          key: "type",
          scopedSlots: { customRender: "showType" },
        },
        {
          title: "物料",
          width: 170,
          dataIndex: "userExts",
          key: "userExts",
          scopedSlots: { customRender: "showMaterial" },
        },*/
        {
          title: "操作",
          key: "operation",
          width: 140,
          scopedSlots: { customRender: "operation" },
        }
      ],
      // 部门集合
      logs: [],
      pagination: {
        total: 0,
        current: 1,
        showTotal: (total) => {
          return `共 ${total} 条`;
        },
      },
      queryParams: {
        limit: 10,
        page: 0,
        searchCondition: {},
      },
      loading: false,
      keyword: "",
      type:undefined,

      url: "",
      preview_visible: false,


      visiable_appraise: false,
      record: {},
      form: this.$form.createForm(this),

      user:{},
      fileList:[],

      appraise_visible:false,
      appraiseList:[],
      page_id:0, // 分页的id
      userId:undefined,
      deptId:undefined,
      typeDisabled:false

    };
  },
  mounted() {
    this.user = getUserInfo();
    console.log(this.user);
    this.deptId = this.user.dept_id;
    if( this.deptId == 132 ) { // 武汉供电公司营销运行中心
      this.type = 1; // 新住配
      this.typeDisabled = true;
    } else if( this.deptId == 133 ) { // 武汉供电公司迁改办
      this.type = 2; // 迁改
      this.typeDisabled = true;
    }
    console.log( this.type);
    this.getList();
  },
  methods: {
    moment,
    getList(flag) {
      if (this.loading) return;
      this.loading = true;
      if (flag == true) {
        this.pagination.current = 1;
      }
      this.queryParams.page = this.pagination.current - 1;

      if (this.keyword) {
        this.queryParams.searchCondition.keyword = this.keyword;
      } else {
        delete this.queryParams.searchCondition.keyword;
      }

      if (this.type) {
        this.queryParams.searchCondition.type = this.type;
      } else {
        delete this.queryParams.searchCondition.type;
      }

      if (this.status === 1 || this.status === 0) {
        this.queryParams.searchCondition.status = this.status;
      } else {
        delete this.queryParams.searchCondition.status;
      }

      userListPage(this.queryParams)
        .then((res) => {
          console.log(res);
          this.logs = res.list;
          this.pagination.total = res.total;
        })
        .finally((res) => {
          this.loading = false;
        });
    },
    onPageChange(pagination, filters, sorter) {
      this.pagination = pagination;
      this.queryParams.page = pagination.current - 1;
      this.getList();
    },

    reset() {
      // clear conditions
      this.keyword = "";
      if( this.deptId != 132 && this.deptId != 133 ) {
        this.type = undefined;
      }
      this.pagination.current = 1;
      this.queryParams.page = 0;
      this.status = undefined;
      this.getList();
    },

    showPic(url) {
      console.log(url);
      this.url = JSON.parse(url)[0];
      if (this.url.endsWith(".pdf")) {
        window.open(this.url);
      } else {
        this.preview_visible = true;
      }
    },

    appraise(record) {
      this.record = record;
      this.fileList = [];
      let opt = {
        searchCondition:{
          fullUnitName:record.fullUnitName
        }
      }
      list_imple_by_fullUnitName(opt).then((res)=>{
        console.log(res);
        this.projectNames = res;
        this.visiable_appraise = true;
      });
    },

    getUrl() {
      let urls = [];
      for (let file of this.fileList) {
        console.log(file);
        if (file.status == "done") {
          urls.push(file.url);
        }
      }
      return JSON.stringify(urls);
    },

    save_handle() {
      // this.$message.warning("评价！");

      this.form.validateFields((err, values) => {
        // console.log(values);
        if (!err) {
          if( this.loading ) {
            return;
          }

          this.loading = true;

          console.log(values);

          let opt = {
            userId:this.record.id,
            appraise:values.appraise,
            appraiseTime: values.appraiseTime.format("YYYY-MM-DD HH:mm:ss"),
            deptName:values.deptName,
            extMaterialName:values.extMaterialName,
            fullUnitName:values.fullUnitName,
            projectName:values.projectName,
            type:values.type,
            urls:this.getUrl()
          };

          console.log(opt);

          save_appraise(opt)
            .then((res) => {
              this.$message.warning("评价成功！");
            })
            .finally((res) => {
              this.loading = false;
              this.closeMe();
            });
        }
      });
    },

    closeMe() {
      this.visiable_appraise = false;
      this.record = {};
    },

    handleChange(info) {
      console.log(info.file.status);
      let fileList = [...info.fileList];

      fileList = fileList.map((file) => {
        if (file.response) {
          // console.log(file);
          file.url = file.response.data.url;
          // file.name = "";
        }
        return file;
      });
      this.fileList = fileList;
      // console.log(this.fileList);
    },

    beforeUpload(file, fileList) {
      if( file.size > 1048576 ) {
        this.$message.error("文件超过限制，请重新上传！");
        fileList.splice(-1,1);
        return false;
      }
      return true;
    },

    queryAppraise(record){
      if( !this.userId ) {
        this.userId = record.id;
      }
      let opt = {
        // userId:this.userId,
        id : this.page_id, // 这里分页处理
        fullUnitName:record.fullUnitName
      };
      list_appraise(opt)
        .then((res) => {
          if( res.length > 0 ) {
            this.page_id = res[res.length-1].id;
          }
          this.appraiseList = this.appraiseList.concat(res);
        })
        .finally((res) => {
          this.appraise_visible = true;
        });
    },

    onClose() {
      console.log("关闭侧边栏。。。");
      this.page_id = 0;
      this.userId = undefined;
      this.appraiseList = [];
      this.appraise_visible = false;
    },

    showUrl(urls) {
      let html = '';
      if( urls ) {
        let tmp = JSON.parse(urls);
        tmp.forEach(function(item,idx){
          if( html.length > 0 ) {
            html += ";";
          }
          html += '<a target="_blank" style="color:blue" href="'+item+'">'+ "附件_" + (idx+1) +'</a>';
        });
      }
      return html;
    },
    deleteAppraise(appraiseId){
      var self = this;
      Modal.confirm({
        title: "提示",
        content: "确定要删除吗？",
        centered: true,
        onOk() {
          delete_appraise(appraiseId)
            .then((res) => {
              self.$message.success("操作成功");
              self.page_id = 0;
              self.appraiseList = [];
              self.queryAppraise();
            })
            .finally((res) => {
            });
        },
      });
    },
    getType(type) {
      for(let i = 0;i < types.length;i ++) {
        if( type == types[i].id ) {
          return types[i].name;
        }
      }
      return type;
    },

    getMaterial(record) {
      try {
        let exts = record.userExts;
        let material = [];
        if( exts ) {
          exts.forEach(function(item,idx){
            material.push(item.materialName);
          });
        }
        return material.join(",");
      }catch(e){
        console.log(e);
      }
      return "";
    }

    //
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.other-filter {
  display: flex;
  height: 50px;
  align-items: center;

  .mr-20 {
    margin-right: 20px;
  }
}

.icons-list :deep(.anticon) {
  margin-right: 6px;
  font-size: 24px;
}
</style>

